<section>
    <div class="container">
        <div class="row">
            <div class="col-lg-12 mt-4 mb-5">
                <div class="cctvcouncelling__sec">
                    <div class="councellist__flex">
                        <div class="counceltitle__flex">
                            <div>
                                <h5 class="councel__name">Print Building AssetQR Detail</h5>
                            </div>
                        </div>
                        <table class="table_campus">
                            <tbody>
                                <tr>
                                    <td class="campus_list">
                                        Campus
                                    </td>

                                    <td class="campus_text">
                                        <select name="" id="" style="width: 215px;" class="drpdwn"
                                            (change)="onSelectedBuilding($event)">
                                            <option value="">Select Campus</option>
                                            <option *ngFor="let data of campusdetails" [value]="data.campusId">
                                                {{data.campusName}}</option>
                                        </select>

                                    </td>

                                    <td class="campus_list">
                                        Building
                                    </td>
                                    <td class="campus_text">
                                        <select name="" id="" style="width: 215px;" class="drpdwn" (change)="onSelectedTableList($event)">
                                            <option value="">Select Building</option>
                                            <option value="" *ngFor="let data of buildingDetails" [value]="data.buildingId">{{data.buildingName}}</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- <div class="campus_list">
                           
                        </div> -->
                        <div class="ibox-content">
                            <mat-card>
                                <ng-container *ngIf="dataAvailable; else noData">
                                    <!--- no data-->
                                    <div class="searchpaginator">
                                        <div class="table_search">
                                            <input type="text" class="form-control" (keyup)="applyFilter($event)"
                                                placeholder="Search">
                                        </div>
                                        <div>
                                            <mat-paginator [pageSize]="10"
                                                [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
                                        </div>

                                    </div>
                                    <div class="table-responsive">
                                        <mat-card-content>
                                            <table mat-table [dataSource]="printQRData" class="table_resize">
                                                <ng-container matColumnDef="fusioncode">
                                                    <th mat-header-cell *matHeaderCellDef class="resizer"> Fusion Code
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;">
                                                        {{row.orcFusionBuildingCode}}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="buildingName">
                                                    <th mat-header-cell *matHeaderCellDef> Building Name
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                        {{row.buildingName}} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="entity">
                                                    <th mat-header-cell *matHeaderCellDef> Entity </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                        {{row.orgName}} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="noofassests">
                                                    <th mat-header-cell *matHeaderCellDef> No of Assets</th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;">
                                                        {{row.totalAssets}} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="startingnumber">
                                                    <th mat-header-cell *matHeaderCellDef> Starting Number</th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;">
                                                        {{row.startingNumber}} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="endingnumber">
                                                    <th mat-header-cell *matHeaderCellDef> Ending Number</th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: right;">
                                                        {{row.endingNumber}} </td>
                                                </ng-container>
                                                <ng-container matColumnDef="status">
                                                    <th mat-header-cell *matHeaderCellDef> Status
                                                    </th>
                                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                                        {{row.approveStatus}}
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="generateqr">
                                                    <th mat-header-cell *matHeaderCellDef> Generate QR
                                                    </th>
                                                    <td mat-cell *matCellDef="let row">
                                                        <button (click)="alldata(row)"
                                                            class="view_details">GenerateQR</button>
                                                    </td>
                                                </ng-container>
                                                <tr mat-header-row *matHeaderRowDef="displayedColumns  sticky: true">
                                                </tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                                                <tr class="mat-row" *matNoDataRow>
                                                    <td class="mat-cell" class="not_matchdata" colspan="8">No data
                                                        matching the filter
                                                    </td>
                                                </tr>
                                            </table>
                                        </mat-card-content>
                                    </div>
                                </ng-container>
                              
                            </mat-card>
                            <ng-template #noData>
                                <section class="section_one">
                                    <div class="cctvcouncelling__sec">
                                        <div class="councellist__flex">
                                            <div>
                                                <div class="nodata_center">
                                                    <figure class="mb-0">
                                                        <img src="../../../../assets/image/nodata.png" alt="nodata"
                                                            class="nodata">
                                                    </figure>
                                                    <p class="no_data">No Data Found</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>



<!-- =======Loading ========== -->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>